
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetojyotilingayatra() {



    const cardData =
    {
        keyword: 'Pune to Jyotirlinga Yatra Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Jyotirlinga Yatra Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Jyotirlinga Yatra Innova Crysta Cab, providing a luxurious, spacious, and spiritually enriching journey designed for devotees visiting Maharashtra’s revered Jyotirlinga temples. Covering destinations such as Bhimashankar, Trimbakeshwar, Grishneshwar, and more in a 4–6 day pilgrimage circuit, our Innova Crysta vehicles feature plush leather interiors, ample legroom, air-conditioning, and generous luggage space—ensuring comfort throughout the spiritual odyssey . With experienced chauffeurs familiar with temple routes and ghat roads, door-to-door pickups from any location in Pune, flexible booking options (one-way, round-trip, or custom multi-day itineraries), GPS-enabled cabs, and 24/7 customer support, Meghana Cab ensures your Pune to Jyotirlinga Yatra Innova Crysta Cab is not just a journey, but a serene and uplifting experience.',


        top: ' Jyotilinga of Maharashtra to Visit with Meghana Cab',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga (Pune District)",
    "description": "Located in the dense Sahyadri forests at an elevation of 3,074 ft, Bhimashankar is one of the most important Jyotirlingas in India. The temple, built in Hemadpanthi-Nagara style by Nana Phadnavis, honors Lord Shiva as Bhimashankar—slayer of the demon Tripurasura. Pilgrims flock here for its spiritual aura, surrounding wildlife sanctuary, origin point of the Bhima River, and serene forest trekking paths. Maha Shivratri and Kartik Poornima attract massive crowds."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga (Nashik District)",
    "description": "Trimbakeshwar, near the source of the holy Godavari River, features a uniquely sacred lingam with three faces symbolizing Brahma, Vishnu, and Shiva. Built in black stone by Peshwa Nana Saheb in the 18th century, the temple is surrounded by Brahmagiri hills and is closely tied to the Kumbh Mela tradition. Devotees visit to seek liberation (moksha), perform Narayan Nagbali rites, and bathe in the sacred Kushavarta kund."
  },
  {
    "title": "Grishneshwar Jyotirlinga (Aurangabad District)",
    "description": "Located near the UNESCO-listed Ellora Caves, the Grishneshwar temple is the smallest Jyotirlinga shrine and is rich in legend. Reconstructed in the 18th century by Queen Ahilyabai Holkar, it showcases red basalt architecture with intricate carvings and a five-tiered shikhara. The temple is associated with the pious woman Ghushma, whose devotion revived her son and led to Lord Shiva’s appearance as Grishneshwar."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga (Hingoli District)",
    "description": "Regarded as the first of the 12 Jyotirlingas by many, Aundha Nagnath is located in Hingoli district of Marathwada. The temple’s black stone structure is adorned with exquisite carvings of sages, animals, and mythological tales. It is said to have been built by the Pandavas during their exile and has a subterranean sanctum sanctorum. The temple complex is expansive and deeply revered across the region."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga (Beed District)",
    "description": "This shrine in Parli is linked to a blend of Shaiva and Vaishnava traditions and is said to grant health and healing. The temple has a distinct wooden sabhamandap, sculpted stone pillars, and houses a Swayambhu Shiva lingam. Festivals like Shravan Maas, Mahashivratri, and Vaikuntha Ekadashi are celebrated with grandeur. According to legend, this is where Ravana tried to take Shiva to Lanka, leading to the formation of this Jyotirlinga."
  }
],

     "services": [
    {
      "name": "Pune to Jyotirlinga Yatra Innova Crysta Cab Booking",
      "description": "Begin your spiritual journey from Pune to the revered Jyotirlinga temples in absolute comfort with our premium Innova Crysta cab booking. Designed for long-distance religious tours, this service ensures a peaceful and hassle-free experience with spacious seating, climate control, and professional chauffeurs guiding your pilgrimage."
    },
    {
      "name": "One Way Innova Crysta Pune Jyotirlinga",
      "description": "For pilgrims planning a single-leg journey to any of the Jyotirlinga temples from Pune, our one-way Innova Crysta cab offers great value, reliable service, and flexibility with pick-up and drop locations."
    },
    {
      "name": "Round Trip Innova Crysta Pune Jyotirlinga",
      "description": "Book a round trip Innova Crysta taxi from Pune for a complete Jyotirlinga pilgrimage tour. Enjoy same-vehicle convenience, return scheduling flexibility, and relaxed, uninterrupted travel."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Jyotirlinga",
      "description": "Travel across states and spiritual sites in an air-conditioned Innova Crysta, ensuring maximum comfort and a soothing journey no matter the weather or distance."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Jyotirlinga",
      "description": "Our courteous and experienced drivers are well-versed with temple routes and provide a calm and respectful environment, enhancing your spiritual journey from Pune to various Jyotirlinga temples."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Jyotirlinga",
      "description": "Hire a private Innova Crysta taxi for your group or family to undertake a personalized and peaceful Jyotirlinga pilgrimage. Enjoy complete privacy and flexible travel schedules."
    },
    {
      "name": "Online Booking Innova Crysta Pune Jyotirlinga",
      "description": "Secure your cab online for a hassle-free Jyotirlinga Yatra from Pune. Access real-time booking, transparent pricing, and instant confirmation with our user-friendly platform."
    },
    {
      "name": "Jyotirlinga Pilgrimage Innova Crysta",
      "description": "Specially curated for religious travelers, this package covers key Jyotirlinga sites such as Trimbakeshwar, Bhimashankar, and Grishneshwar from Pune in a comfortable Innova Crysta cab."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Jyotirlinga",
      "description": "Enjoy reclining seats, ample luggage space, and a quiet ride in our Innova Crysta taxis—perfect for the long hours of travel typically required in a Jyotirlinga pilgrimage circuit."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Jyotirlinga",
      "description": "Our budget-friendly packages for Jyotirlinga temple visits provide economic yet comfortable cab services with no compromise on safety or vehicle quality."
    },
    {
      "name": "Religious Tour Innova Crysta Pune",
      "description": "We specialize in religious tour cab services from Pune, including temple visits, pilgrimages, and spiritual circuits such as the Jyotirlinga Yatra, Ashtavinayak Darshan, and more."
    },
    {
      "name": "Family Trip Innova Crysta Jyotirlinga",
      "description": "Plan your spiritual trip with loved ones in our 6–7 seater Innova Crysta. Spacious, clean, and equipped with entertainment and comfort features for a pleasant pilgrimage."
    },
    {
      "name": "Reliable Innova Crysta Taxi Jyotirlinga",
      "description": "Count on punctuality, safety, and clean vehicles when you book our Innova Crysta cabs for your Jyotirlinga journey. We ensure every part of your trip is worry-free."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta taxis are ideal for multi-state religious travel, offering strong road performance, ample space, and smooth long-haul experiences."
    },
    {
      "name": "Weekend Trip Innova Crysta Jyotirlinga",
      "description": "Plan a weekend Jyotirlinga temple visit from Pune with our dedicated cab service. Whether it’s a visit to Bhimashankar or Trimbakeshwar, enjoy a spiritually uplifting weekend ride."
    }
  ],
  "tableData": [
    ["Pune to Jyotirlinga Yatra Innova Crysta Cab Booking", "One Way Innova Crysta Pune Jyotirlinga"],
    ["Round Trip Innova Crysta Pune Jyotirlinga", "AC Innova Crysta Taxi Pune Jyotirlinga"],
    ["Chauffeur Driven Innova Crysta Pune Jyotirlinga", "Private Innova Crysta Taxi Pune Jyotirlinga"],
    ["Online Booking Innova Crysta Pune Jyotirlinga", "Jyotirlinga Pilgrimage Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Jyotirlinga", "Budget Innova Crysta Taxi Pune Jyotirlinga"],
    ["Religious Tour Innova Crysta Pune", "Family Trip Innova Crysta Jyotirlinga"],
    ["Reliable Innova Crysta Taxi Jyotirlinga", "Long Distance Innova Crysta Taxi"],
    ["Weekend Trip Innova Crysta Jyotirlinga", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab for Pune to Jyotirlinga Yatra",
    "WhyChoosedescription": "Embark on a sacred Jyotirlinga Yatra from Pune in a premium Innova Crysta, visiting some of India’s most revered Shiva temples such as Trimbakeshwar, Bhimashankar, Aundha Nagnath, Grishneshwar, and Parli Vaijnath. Our cab service offers comfort, reliability, and spiritual peace throughout your journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Ride for Long Pilgrimages",
    "WhyChoosedescription": "Our Innova Crysta vehicles are ideal for multi-day spiritual tours. With ample legroom, reclining seats, AC, and luggage space, passengers of all ages—including elderly devotees—can travel long distances in total comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Temple Routes",
    "WhyChoosedescription": "Our trained chauffeurs have in-depth knowledge of Jyotirlinga locations, ideal travel routes, darshan timings, and nearby facilities. They ensure a well-paced journey and help you maintain your yatra schedule with ease."
  },
  {
    "WhyChooseheading": "Sanitized, Safe, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Every Innova Crysta cab undergoes deep cleaning and regular mechanical checks before each trip. We prioritize safety and hygiene to provide a stress-free and health-conscious travel environment throughout your Yatra."
  },
  {
    "WhyChooseheading": "Customizable Yatra Itineraries – One Temple or Full Circuit",
    "WhyChoosedescription": "Whether you're visiting a single Jyotirlinga like Bhimashankar or planning a multi-day tour covering 3–5 temples, we offer fully customizable routes and durations to suit your spiritual needs and comfort."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowances, parking, and state taxes. We provide all-inclusive quotes with no hidden fees—allowing you to focus on your prayers, not your wallet."
  },
  {
    "WhyChooseheading": "Ideal for Families, Devotee Groups, and Elderly Pilgrims",
    "WhyChoosedescription": "Our Innova Crysta cab is the preferred choice for groups seeking a smooth, serene, and safe pilgrimage experience. Comfortable for elders and spacious enough for joint family trips, it supports every type of Yatra traveler."
  },
  {
    "WhyChooseheading": "24/7 Booking and Yatra Planning Support",
    "WhyChoosedescription": "From booking assistance to itinerary planning, our support team is available round-the-clock. We help coordinate temple visits, suggest optimal travel routes, and adjust schedules as per your devotional plans."
  }
]






















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta for Pune to Jyotirlinga Yatra?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and hassle-free booking."
    },
    {
        question: "Which Jyotirlinga temples can be covered from Pune on this yatra?",
        answer: "Popular Jyotirlinga temples covered include Trimbakeshwar, Bhimashankar, Grishneshwar, and others depending on your chosen itinerary."
    },
    {
        question: "Is the Innova Crysta suitable for long pilgrimage journeys?",
        answer: "Yes, the Innova Crysta offers ample space and comfort, making it ideal for long yatra trips."
    },
    {
        question: "Can I book the cab for a multi-day Jyotirlinga yatra?",
        answer: "Yes, we offer customizable multi-day packages for your Jyotirlinga yatra."
    },
    {
        question: "Are the vehicles sanitized before pilgrimage trips?",
        answer: "Yes, all vehicles are thoroughly sanitized prior to every journey for your safety."
    },
    {
        question: "What is included in the Pune to Jyotirlinga yatra cab fare?",
        answer: "The fare includes fuel, driver allowance, tolls, and taxes. Additional stops or waiting times may incur extra charges."
    },
    {
        question: "Can I request stops for meals and sightseeing during the yatra?",
        answer: "Yes, meal and sightseeing stops can be arranged as per your preferences."
    },
    {
        question: "Are the drivers experienced with pilgrimage routes?",
        answer: "Yes, our drivers are familiar with pilgrimage routes and ensure a safe and smooth journey."
    },
    {
        question: "What payment methods are accepted for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How many passengers can travel comfortably in the Innova Crysta?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers with ample luggage space."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta made our Jyotirlinga Yatra comfortable and memorable. Excellent service by Meghana Cab.”',
    },
    {
        name: 'Ms. Aarti Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommended for pilgrimage trips. The driver was punctual, and the vehicle was clean and spacious.”',
    },
];





































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToJyotirlingaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Jyotirlinga Yatra Innova Crysta Cab",
  "description": "Comfortable and chauffeur-driven Innova Crysta cabs from Pune for Jyotirlinga Yatra. Perfect for family and religious travel. One way and round trip booking available with AC cabs and online confirmation.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Pilgrimage Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Jyotirlinga Yatra"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-jyotirlinga-innova-crysta-cab"
  }
};







    return (
        <div>


<Helmet>
  <title>Pune to Jyotirlinga Yatra Innova Crysta Cab | Pilgrimage Taxi Booking</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta for Pune to Jyotirlinga Yatra. AC taxi service for religious and family travel. Comfortable, safe and affordable pilgrimage cab booking online."
  />
  <meta
    name="keywords"
    content="Pune to Jyotirlinga Yatra Innova Crysta Cab Booking, One Way Innova Crysta Pune Jyotirlinga, Round Trip Innova Crysta Pune Jyotirlinga, AC Innova Crysta Taxi Pune Jyotirlinga, Chauffeur Driven Innova Crysta Pune Jyotirlinga, Private Innova Crysta Taxi Pune Jyotirlinga, Online Booking Innova Crysta Pune Jyotirlinga, Jyotirlinga Pilgrimage Innova Crysta, Comfortable Innova Crysta Cab Pune Jyotirlinga, Budget Innova Crysta Taxi Pune Jyotirlinga, Religious Tour Innova Crysta Pune, Family Trip Innova Crysta Jyotirlinga, Reliable Innova Crysta Taxi Jyotirlinga, Long Distance Innova Crysta Taxi, Weekend Trip Innova Crysta Jyotirlinga"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJyotirlingaSchema)}
  </script>
</Helmet>
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetojyotilingayatra;